import * as React from "react";
import PropTypes from "prop-types";
import Button from "./Button";

const ManualCopyModal = ({ value, onDone }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "15px",
          maxWidth: "500px",
          width: "100%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <h3 style={{ margin: 0 }}>Manual Copy Required</h3>
        <p style={{ margin: 0, textAlign: "left" }}>
          We couldn&#39;t access your clipboard automatically. Please copy the text below manually:
        </p>
        <textarea
          readOnly
          style={{
            height: "135px",
            padding: "10px",
            margin: "10px 0",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
          value={value}
          onFocus={(e) => e.target.select()}
        />
        <div style={{ display: "flex", gap: "10px" }}>
          <Button primary style={{ flex: 1 }} onClick={onDone}>
            I&#39;ve copied it
          </Button>
        </div>
      </div>
    </div>
  );
};

ManualCopyModal.propTypes = {
  value: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default ManualCopyModal;
